import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import { A } from 'components/common/Link/Link'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'

const CheckboxDescription = ({
  promo: {
    promotionTitle,
    promotionDescription
  } = {},
  toggleHandlers: {
    onClick
  },
  expanded
}) =>
  <Wrapper>
    <PromotionTitle> { promotionTitle } </PromotionTitle>
    {
      promotionDescription &&
        <Fragment>
          <PromotionDescription hidden={ !expanded }>
            <HTMLContainer content={ promotionDescription } />
          </PromotionDescription>
          <ExpandDescription prevent handler={ onClick }>{ expanded ? 'Hide Details' : 'View Details' }</ExpandDescription>
        </Fragment>
    }
  </Wrapper>

CheckboxDescription.propTypes = {
  expanded: PropTypes.bool,
  promo: PropTypes.shape({
    promotionTitle: PropTypes.string,
    promotionDescription: PropTypes.string
  }),
  toggleHandlers: PropTypes.shape({
    onClick: PropTypes.func
  })
}

export default CheckboxDescription

const Wrapper = styled.div`
  margin-left: 0;
`

const PromotionTitle = styled.span`
  display: inline-block;
  vertical-align: middle;
  ${Mixin.font.GothamBold(14)}
`

const PromotionDescription = styled.div`
  margin: 5px 0 3px;
  color: ${Theme.colors.black};
  ${Mixin.font.GothamBook(12, 400)}
`

const ExpandDescription = styled(A)`
  display: block;
  font-weight: 600;
  padding: 5px 0;
`
